var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYiiPlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0073BB",
    d: "M107.131 1.228c-14.253.534-31.578 18.435-25.65 35.13 6.275 16.565 10.296 28.348 11.137 46.83 15.062-15.155 28.901-31.609 30.018-50.7.366-15.493-6.967-26.911-15.505-31.26zM69.549 70.012c-2.139 3.823-4.946 7.978-8.606 12.528-7.691 9.693-15.446 25.593-13.061 44.232 31.771-3.506 41.693-27.353 42.563-40.457-5.987-9.034-16.85-14.596-20.896-16.303zM5.477 12.815c-1.128 14.583 5.11 36.267 30.397 43.169 10.648 3.153 18.109 5.096 26.186 8.028 11.809 4.291 21.078 9.768 28.422 19.221-1.363-16.265-8.062-34.902-18.759-49.441C56.462 13.052 30.034 3.097 5.477 12.815z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYiiPlain);
export default __webpack_public_path__ + "static/media/YiiPlain.335c8c3f46770cc5772e12bcd18050ac.svg";
export { ForwardRef as ReactComponent };